interface SectionHeadingProps {
    title: string;
    description?: string;
}

export default function SectionHeading({
    title,
    description,
}: SectionHeadingProps) {
    return (
        <div className="space-y-0.5">
            <h4 className="text-sm font-medium">{title}</h4>
            {description && (
                <p className="text-xs font-medium text-subtle-foreground">
                    {description}
                </p>
            )}
        </div>
    );
}
